module.exports = __webpack_public_path__ + "img/icon_classify_pre.0a82e3e8.png";